<div #dropdown="ngbDropdown"
     ngbDropdown
     container="body"
     display="dynamic"
     placement="bottom-end">
  <button ngbDropdownToggle
          type="button"
          class="btn btn-dark">
    <i class="fa-light fa-bars me-1"></i>
  </button>
  <ul ngbDropdownMenu class="dropdown-menu-dark px-3 py-2">
    <li class="list-group-item d-flex justify-content-between align-items-center">
      <div class="form-check form-check-inline form-switch">
        <input id="switch-cells"
               class="form-check-input"
               type="checkbox"
               [checked]="displayCells"
               (click)="displayCellsValueChanged()">
        <label class="form-check-label">Cells</label>
      </div>
      <i class="fa-light fa-globe"></i>
    </li>
    <li class="list-group-item d-flex justify-content-between align-items-center">
      <div class="form-check form-check-inline form-switch">
        <input id="switch-footprints"
               class="form-check-input"
               type="checkbox"
               [checked]="displayFootprints"
               (click)="displayFootprintsValueChanged()">
        <label class="form-check-label">Footprints</label>
      </div>
      <i class="fa-regular fa-hexagon text-warning"></i>
    </li>
    <li class="list-group-item d-flex justify-content-between align-items-center">
      <div class="form-check form-check-inline form-switch">
        <input id="switch-sky-objects"
               class="form-check-input"
               type="checkbox"
               [checked]="displaySkyObjects"
               (click)="displaySkyObjectsValueChanged()">
        <label class="form-check-label">Sky objects</label>
      </div>
      <i class="fa-solid fa-circle text-primary"></i>
    </li>
  </ul>
</div>
